import React from 'react';
import Select from 'react-select';

const MultiSelectInput = ({
  options,
  selectedOptions,
  placeholder,
  setSelectedOptions,
  noOptionsMessage,
  getOptionValue,
  getOptionLabel
}) => {

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      outline: 'none',
      boxShadow: state.isFocused ? '0 0 6px #4d90fe' : '0',
      border: state.isFocused ? '1px solid #4d90fe' : '1px solid #DDDDDD',
      WebkitTransition: 'all 0.1s ease-in-out',
      MozTransition: 'all 0.1s ease-in-out',
      MsTransition: 'all 0.1s ease-in-out',
      OTransition: 'all 0.1s ease-in-out',
      minHeight: '38px',
      margin: 0,
      padding: 0,
    }),
    input: (provided) => ({
      ...provided,
      margin: 0,
      padding: 0,
    }),
  };

return (
    <Select
      options={options}
      value={selectedOptions}
      getOptionValue={(option) => option[getOptionValue || 'id']} 
      getOptionLabel={(option) => option.name}
      onChange={setSelectedOptions}
      isMulti
      placeholder={placeholder || 'Selecionar...'}
      styles={customStyles}
      noOptionsMessage={() => noOptionsMessage || 'Nehuma opção disponivel'}
    />
  );
};

export default MultiSelectInput;
